import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from 'react';
import { fetchUsersData, updateUserRole } from "../services"
import { MyContext } from '..';
import { AgGridReact } from 'ag-grid-react';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import { Input } from '../GitHubComponents/Inputs';
import Button from '../GitHubComponents/Button'
import Modal from '../GitHubComponents/Modal';
import Alert from '@mui/material/Alert';

export default function Users(props) {
    document.title = props.title
    const { backendUrl } = useContext(MyContext)
    const queryParameters = new URLSearchParams(window.location.search);
    const organizationCode = queryParameters.get("orgcode")?.toUpperCase() || props.orgCode;
    const username = queryParameters.get("username") || props.username
    const subCode = queryParameters.get("subcode") || props.subCode
    const role = queryParameters.get("role") || props.role
    const [editable, setEditable] = useState(false)

    const [usersData, setUsersData] = useState([])
    const gridRef = useRef();
    const [selectedRows, setSelectedRows] = useState([])
    const [dbRoles, setDbRoles] = useState([])
    // const [roles, setRoles] = useState([])

    const [alert, setAlert] = useState({
        show: false,
        message: "",
        type: ""
    })
    const fetchData = useCallback(async () => {
        try {
            const data = await fetchUsersData(backendUrl, organizationCode, subCode, username, role);
            setUsersData(data.users);
            setEditable(data.editable)
            setDbRoles(data.dbRoles)
        } catch (error) {
            console.error('Error fetching Users data:', error);
        }
    }, [backendUrl, organizationCode, username, subCode, role])
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    const columns = [
        { field: 'id', headerName: 'Id', width: 100, pinned: 'left', headerCheckboxSelection: true, checkboxSelection: true },
        { field: 'full_name', headerName: 'Name', width: 180, pinned: 'left' },
        { field: 'email', headerName: 'email', width: 230 },
        { field: 'username', headerName: 'Username', width: 190 },
        { field: 'phone_number', headerName: 'Phone Number', width: 150 },
        { field: 'description', headerName: 'Description', flex: 2 },
        { field: 'roles', headerName: 'roles', width: 200, pinned: 'right' }

    ];
    if (editable) {
        const actionColumn = {
            field: 'username',
            headerName: 'Actions',
            width: 100,
            pinned: 'right',
            cellRenderer: ({ value }) => (
                <Link
                    onClick={() => {
                        try {
                            props.setUsername(value)
                        } catch (error) {
                            console.log(error);
                        }
                    }}
                    to={`${queryParameters.get("subcode") ? `/user/profile?subcode=${subCode}&username=${value}` : `/admin/users/profile`}`}>
                    <EditIcon color="primary" />
                </Link>
            ),
        }
        columns.push(actionColumn)
    }
    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            'quickFilterText',
            document.getElementById('filter-text-box').value
        );
    }, []);
    const defaultColDef = useMemo(() => {
        return {
            filter: true,
        };
    }, []);
    const handleSelectionChanged = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        setSelectedRows(selectedRows)
    };

    const [modalOpen, setModalOpen] = useState(false);

    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const handleRoleSubmit = async (roles) => {
        const response = await updateUserRole(backendUrl, subCode, selectedRows, roles)
        if (response.code === 201 || response.code === 200) {
            setModalOpen(false);
            setAlert({
                type: "success",
                message: response.message,
                show: true,
            });
            fetchData()
        } else {
            setAlert({
                type: "error",
                message: response.message,
                show: true,
            });
        }
    }
    return (
        <div style={{ padding: "0px 25px", display: "flex", flexDirection: "column",}} className='grid-body'>
            {alert.show && <Alert variant={"outlined"} severity={alert.type} onClose={() => { setAlert({ show: false }) }} style={{ position: "absolute", right: "26px", zIndex: "2", background: "aliceblue", width: "45vw", margin: "10px auto" }}>{alert.message}</Alert>}
            {modalOpen && <Modal header={"Update the role of selected Users"} inputHeader={"Select the roles"} submitBtnTxt={"Update selected role"} show={modalOpen} handleClose={closeModal} inputMetaData={dbRoles} setInputMetaData={setDbRoles} onSubmit={handleRoleSubmit} />}
            <div className='grid-head d-flex'>
                <div className="example-header">
                    <span>Quick Filter:</span>
                    <Input type={"text"} id={"filter-text-box"} onInput={onFilterTextBoxChanged} style={{ display: "inline-block" }} />
                </div>
                {selectedRows.length > 0 && <Button text={"Update role"} onClick={openModal} style={{ color: "white ", backgroundColor: "#1f883d", marginTop: "19px" }} />}
            </div>
            <div style={{ height: "80vh", width: '100%' }} className='ag-theme-quartz'>
                <AgGridReact ref={gridRef} rowData={usersData} columnDefs={columns} defaultColDef={defaultColDef} rowSelection={'multiple'} suppressRowClickSelection={true} suppressCopyRowsToClipboard={true} onSelectionChanged={handleSelectionChanged} pagination={true} />
            </div>
        </div>
    )
}
